import type { ReactElement, ReactNode } from 'react';
import styles from './InputErrorWrapper.module.scss';

type InputErrorWrapperProps = {
  message: string;
  children: ReactNode;
  errorId: string;
};

export function InputErrorWrapper({
  message,
  children,
  errorId
}: InputErrorWrapperProps): ReactElement {
  return (
    <div className={message ? styles.error : ''} data-error={errorId}>
      {children}
      {message && (
        <div className={styles.errorContainer}>
          <span>{message}</span>
        </div>
      )}
    </div>
  );
}
